import { gql } from "@apollo/client";

import type { PractitionerProperties } from "@shared/types/graphqlGenerated";

/**
 * @deprecated Shared fragment types are deprecated. Use or pick from generated types instead.
 */
interface PractitionerFragment {
  id: string;
  uuid: string;
  createdAt: string;
  fullName: string;
  title: string;
  firstName: string;
  lastName: string;
  email: string;
  suffix: string;
  name: string;
  npiApprovalState: number;
  storeId: string;
  storeName: string;
  isStoreOwner: boolean;
  canAccessWpp: boolean;
  updatedAt: string;
  isSignupPending: boolean;
  patientCount: number;
  properties: PractitionerProperties;
  __typename: string;
}

/**
 * @deprecated Shared fragments are deprecated. Indicate field name directly within query/mutation or
 * create a co-located (not shared) fragment, if you need one.
 */
const PRACTITIONER_FRAGMENT = gql`
  fragment PractitionerFragment on Practitioner {
    id
    uuid
    createdAt
    fullName
    title
    firstName
    lastName
    email
    suffix
    name
    npiApprovalState
    storeName
    isStoreOwner
    canAccessWpp
    updatedAt
    isSignupPending
    patientCount
    properties {
      id
      isStudent
    }
    __typename
  }
`;

export type { PractitionerFragment };
export { PRACTITIONER_FRAGMENT };
